import React from 'react';

import { StreetReference } from 'app/model/StreetReference';
import { Reference } from 'app/model/Reference';

export interface StreetReferenceRendererProps {
    streetReference: StreetReference;

    streetTypeConverter: (typeCode: string) => Reference;
}

export const StreetReferenceRenderer = ({
    streetReference,
    streetTypeConverter,
}: StreetReferenceRendererProps) => {
    return (
        <div>
            <span>{streetTypeConverter(streetReference.type).name}</span>&nbsp;
            <span>{streetReference.name}</span>
        </div>
    );
};
